import React, { useContext } from 'react';
import Modal from "./Settings/Modal";
import { AuthContext } from "contexts/AuthContext";

const Footer = ({ setChatBoxSettings, chatBoxSettings }) => {
    const { state } = useContext(AuthContext);
    const isOrgAdmin = state.profile?.roles?.includes('ROLE_ADMIN');

    return (
        <div
            className="margin container flex min-h-[72px] mt-2 items-center justify-between border-t border-[#D2D2D2] px-4 pb-3 pt-5 lg:min-h-[72px] lg:px-0 lg:py-5">
            {isOrgAdmin &&
                <Modal setChatBoxSettings={setChatBoxSettings} chatBoxSettings={chatBoxSettings}/>
            }
            <div className="text-sm">
                © {new Date().getFullYear()} Ozmosys, Inc. All rights reserved.
            </div>
        </div>
    )
};


export default Footer;
